export default __webpack_public_path__ + "static/media/earth_grey.12eb5197.png";